//Submit File Button
document.addEventListener("alpine:init", () => {
    window.Alpine.data("fileInput", (clear_on) => ({
        upload_input: null,
        is_drag_over: false,
        files_with_status: [],
        all_uploaded: true,
        init() {
            this.clear_on = clear_on;
            this.upload_input = this.$refs["file_upload"];
            this.multiple = this.upload_input.attributes.getNamedItem("multiple") ? true : false;
            this.parent_form = this.upload_input.form;
            this.setClearListener();
            this.$watch("files_with_status", () => {
                window.htmx.process(this.$el);
                this.all_uploaded = this.files_with_status.every(
                    ({ upload_status }) => upload_status == "uploaded",
                );
                if (this.all_uploaded) {
                    this.$dispatch("all-files-uploaded");
                } else {
                    this.$dispatch("files-uploading");
                }
            });
        },
        browseFiles() {
            this.upload_input.click();
        },
        handleDrop(event) {
            this.is_drag_over = false;
            this.handleFiles(event.dataTransfer.files);
        },

        handleFileSelection(event) {
            this.handleFiles(event.target.files);
        },
        handleFiles(files) {
            if (!files.length) return;
            const prefix = "file-id-";
            if (this.multiple) {
                for (const file of files) {
                    this.files_with_status.push({
                        id: prefix + Math.random().toString(36).slice(2, 9),
                        file: this.filterFileName(file),
                        upload_status: "pending",
                    });
                }
            } else {
                this.files_with_status = [
                    {
                        id: prefix + Math.random().toString(36).slice(2, 9),
                        file: this.filterFileName(files[0]),
                        upload_status: "pending",
                    },
                ];
            }
        },
        filterFileName(file) {
            const filtered_name = file.name.replace(/%/g, "");
            const filtered_file = new File([file], filtered_name, {
                type: file.type,
                lastModified: file.lastModified,
            });
            return filtered_file;
        },
        removeFile(index) {
            this.files_with_status.splice(index, 1);
        },
        clearFiles() {
            this.files_with_status = [];
            const new_files = new DataTransfer();
            this.upload_input.files = new_files.files;
        },
        setClearListener() {
            //if an clear_on is set listen and clear on it, otherwise
            // clear on any "submit"
            if (this.clear_on) {
                document.addEventListener(this.clear_on, () => {
                    this.clearFiles();
                });
            }

            //always clear previous status on a new submit
            document.addEventListener("submit", () => {
                this.clearFiles();
            });
        },
    }));
});
